var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { unpackStripePortal, unpackClientBalance, unpackCost, unpackAutoRecharge, unpackFundsResponse, unpackPaymentInfo, packAutoRechargeData, packParterAutoRechargeData, packPartnerAddFundsData, unpackAutoRechargePBS, unpackCostPBS, } from "./accounting.mapper";
import { EpartnerBillingSystem, } from "../partners/partners.types";
var triggerInvoicesCreationURL = function (date) {
    return "/invoicing/partners/invoices/".concat(date, "/control/trigger_invoice_generation");
};
var triggerTemplateInvoicesCreationURL = function (date) {
    return "/invoicing/partners/invoices/".concat(date, "/control/trigger_template_invoice_generation");
};
var triggerTemplateReportCreationURL = function (date) {
    return "/invoicing/partners/invoices/".concat(date, "/control/trigger_template_report_generation");
};
var triggerCbpInvoicesCreationURL = function (date) {
    return "/invoicing/partners/invoices/".concat(date, "/control/trigger_zoho_conversation_invoice_generation");
};
var triggerCbpReportCreationURL = function (date) {
    return "/invoicing/partners/invoices/".concat(date, "/control/trigger_conversation_monthly_report_generation");
};
var triggerCbpReportDailyCreationURL = function (date) {
    return "/invoicing/partners/invoices/".concat(date, "/control/trigger_conversation_daily_report_generation");
};
var stripeCreatePortalURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/control/stripe_portal_session");
};
var stripeCreatePortalPartnerURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/control/stripe_portal_session");
};
var clientBalanceURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/info/balance");
};
var partnerBalanceURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/info/conversation_usage?from_year=2023&from_month=10");
};
var channelBalanceURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/info/balance");
};
var channelBalanceListURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/info/channels_balance");
};
var addFundsURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/add_funds");
};
var checkPaymentsInfoURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, paymentId = _a.paymentId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/info/payments/").concat(paymentId);
};
var channelBalanceFilterURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/all/info/balance");
};
var addChannelFundsURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/add_funds");
};
var requestRefundURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/issue_refund");
};
var calculateCostURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/info/calculate_cost");
};
var setAutoRechargeURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/control/update_auto_recharge_settings");
};
var setChannelAutoRechargeURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/control/update_auto_recharge_settings");
};
var getAutoRechargeURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/auto_recharge_settings");
};
var getChannelAutoRechargeURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/projects/").concat(projectId, "/channels/").concat(channelId, "/auto_recharge_settings");
};
var getChannelAutoRechargeListURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/channels_auto_recharge_settings");
};
var addPartnerFundsURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/add_funds");
};
var addPartnerAutoRechargeURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/update_auto_recharge_settings");
};
var addFundsEbanxURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/balance/add");
};
var getEbanxPaymentMethodUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/payment-method/".concat(partnerId);
};
export var triggerInvoicesCreation = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(triggerInvoicesCreationURL(payload.date), {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var triggerTemplateInvoicesCreation = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(triggerTemplateInvoicesCreationURL(payload.date), {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var triggerTemplateReportCreation = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(triggerTemplateReportCreationURL(payload.date), {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var triggerCbpInvoicesCreation = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(triggerCbpInvoicesCreationURL(payload.date), {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var triggerCbpReportCreation = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(triggerCbpReportCreationURL(payload.date), {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var triggerCbpReportDailyCreation = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(triggerCbpReportDailyCreationURL(payload.date), {})];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var stripeCreatePortal = function (_a, redirectUrl) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(stripeCreatePortalURL({
                        partnerId: partnerId,
                        clientId: clientId,
                    }), { redirect_url: redirectUrl })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackStripePortal(data)];
            }
        });
    });
};
export var stripeCreatePortalPartner = function (_a, redirectUrl) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(stripeCreatePortalPartnerURL({
                        partnerId: partnerId,
                    }), { redirect_url: redirectUrl })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackStripePortal(data)];
            }
        });
    });
};
export var getClientBalance = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, appIds = _a.appIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryParams = appIds.length ? { app_ids: appIds.join(",") } : {};
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(clientBalanceURL({
                            partnerId: partnerId,
                            clientId: clientId,
                        }), {
                            params: __assign({}, queryParams),
                        })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackClientBalance(data)];
            }
        });
    });
};
export var getPartnerClientsBalance = function (_a) {
    var partnerId = _a.partnerId, appIds = _a.appIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryParams = appIds.length ? { app_ids: appIds.join(",") } : {};
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerBalanceURL({
                            partnerId: partnerId,
                        }), {
                            params: __assign({}, queryParams),
                        })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackClientBalance(data)];
            }
        });
    });
};
export var getChannelBalance = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(channelBalanceURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackClientBalance(data)];
            }
        });
    });
};
export var getChannelBalanceList = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, channelIds = _a.channelIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryParams = (channelIds === null || channelIds === void 0 ? void 0 : channelIds.length)
                        ? { channel_ids: channelIds.join(",") }
                        : {};
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(channelBalanceListURL({
                            partnerId: partnerId,
                            clientId: clientId,
                        }), {
                            params: __assign({}, queryParams),
                        })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.map(unpackClientBalance)];
            }
        });
    });
};
export var getFilteredChannelsBalance = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelIds = _a.channelIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryParams = (channelIds === null || channelIds === void 0 ? void 0 : channelIds.length)
                        ? { channel_ids: channelIds.join(",") }
                        : {};
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(channelBalanceFilterURL({
                            partnerId: partnerId,
                            clientId: clientId,
                            projectId: projectId,
                        }), {
                            params: __assign({}, queryParams),
                        })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.map(unpackClientBalance)];
            }
        });
    });
};
export var addFunds = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, amount = _a.amount, _b = _a.currency, currency = _b === void 0 ? "EUR" : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(addFundsURL({
                        partnerId: partnerId,
                        clientId: clientId,
                    }), { amount: amount, currency: currency })];
                case 1:
                    data = (_c.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var addChannelFunds = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId, amount = _a.amount, _b = _a.currency, currency = _b === void 0 ? "EUR" : _b, billingSystem = _a.billingSystem;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(addChannelFundsURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId,
                    }), { amount: amount, currency: currency })];
                case 1:
                    data = (_c.sent()).data;
                    return [2 /*return*/, billingSystem === EpartnerBillingSystem.PBS
                            ? data
                            : unpackFundsResponse(data)];
            }
        });
    });
};
export var requestRefund = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(requestRefundURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var calculateCost = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, amount = _a.amount, user_initiated_amount = _a.user_initiated_amount, business_initiated_amount = _a.business_initiated_amount, billingSystem = _a.billingSystem;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(calculateCostURL({
                        partnerId: partnerId,
                        clientId: clientId,
                    }), { amount: amount, user_initiated_amount: user_initiated_amount, business_initiated_amount: business_initiated_amount })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, billingSystem === EpartnerBillingSystem.PBS
                            ? unpackCostPBS(data)
                            : unpackCost(data)];
            }
        });
    });
};
export var getAutoRecharge = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getAutoRechargeURL({
                        partnerId: partnerId,
                        clientId: clientId,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackAutoRecharge(data)];
            }
        });
    });
};
export var getChannelAutoRecharge = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getChannelAutoRechargeURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackAutoRecharge(data)];
            }
        });
    });
};
export var getChannelAutoRechargeList = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, billingSystem = _a.billingSystem;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getChannelAutoRechargeListURL({
                        partnerId: partnerId,
                        clientId: clientId,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, billingSystem === EpartnerBillingSystem.PBS
                            ? data.map(unpackAutoRechargePBS)
                            : data.map(unpackAutoRecharge)];
            }
        });
    });
};
export var setAutoRecharge = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, renewalData = _a.renewalData;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(setAutoRechargeURL({
                        partnerId: partnerId,
                        clientId: clientId,
                    }), packAutoRechargeData(renewalData))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackAutoRecharge(data)];
            }
        });
    });
};
export var setChannelAutoRecharge = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, projectId = _a.projectId, channelId = _a.channelId, billingSystem = _a.billingSystem, renewalData = _a.renewalData;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(setChannelAutoRechargeURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        projectId: projectId,
                        channelId: channelId,
                    }), packAutoRechargeData(renewalData))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, billingSystem === EpartnerBillingSystem.PBS
                            ? unpackAutoRechargePBS(data)
                            : unpackAutoRecharge(data)];
            }
        });
    });
};
export var checkPaymentsInfo = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, paymentId = _a.paymentId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(checkPaymentsInfoURL({
                        partnerId: partnerId,
                        clientId: clientId,
                        paymentId: paymentId,
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPaymentInfo(data)];
            }
        });
    });
};
export var addPartnerFunds = function (_a) {
    var partnerId = _a.partnerId, payload = _a.payload;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(addPartnerFundsURL({
                        partnerId: partnerId,
                    }), packPartnerAddFundsData(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updatePartnerAutoRecharge = function (_a) {
    var partnerId = _a.partnerId, payload = _a.payload;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(addPartnerAutoRechargeURL({
                        partnerId: partnerId,
                    }), packParterAutoRechargeData(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getPartnerEbanxAddFunds = function (_a) {
    var partnerId = _a.partnerId, payload = _a.payload;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(addFundsEbanxURL({ partnerId: partnerId }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getPartnerEbanxPaymentMethod = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getEbanxPaymentMethodUrl({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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